export class FileType {
    code: string;
    type: string;
    ext: string;
    constructor() {
        this.code = "";
        this.type = "";
        this.ext = "";
    }
}